import { useEffect, useCallback } from 'react'

import { modalPriorityCreators, ModalType } from '@store/ducks/modalPriority'
import { useAppDispatch, useAppSelector } from '@store/hooks'

type Props = { modalType: ModalType; shouldShow: boolean }

export function useModalPriority({ modalType, shouldShow }: Props) {
	const dispatch = useAppDispatch()
	const { currentModal, dismissedModals } = useAppSelector(
		(state) => state.modalPriority
	)

	const wasDismissed = dismissedModals.includes(modalType)

	const canShow = !wasDismissed && currentModal === modalType

	useEffect(() => {
		dispatch(
			modalPriorityCreators.requestOpen({
				type: modalType,
				want: shouldShow && !wasDismissed,
			})
		)

		return () => {
			dispatch(
				modalPriorityCreators.requestOpen({ type: modalType, want: false })
			)
		}
	}, [dispatch, modalType, shouldShow, wasDismissed])

	const onClose = useCallback(() => {
		dispatch(modalPriorityCreators.dismissModal(modalType))
	}, [dispatch, modalType])

	return {
		canShow,
		onClose,
	}
}
